import React from 'react';
import useStyles from './Styles';
import { IconButton, Grid, Box, Tabs, Tab, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from 'react-redux';

const AboutSidebar = (props) => {
    const classes = useStyles();
    const { onClose } = props;
    const [tab, setTab] = React.useState("about");
    const { chart } = useSelector(state => state.arizona);

    const metrics = {
        "shortage_impacts_to_river_communities_vs_central_arizona": [
            { label: 'Year', value: '20XX' },
            { label: 'Total Colorado River water available', value: 'Xxx,xxx ac-ft' },
            { label: 'Central Arizona availability', value: 'Xx.xx%' },
            { label: 'Western Arizona availability', value: 'XX.xx%' },
        ],
        "shortage_impacts_by_arizona_region": [
            { label: 'Metric Name', value: 'Xxx,xxx ac-ft' },
            { label: 'Metric Name', value: 'Xxx,xxx ac-ft' },
            { label: 'Metric Name', value: 'Xxx,xxx ac-ft' },
            { label: 'Metric Name', value: 'Xxx,xxx ac-ft' },
        ]
    };

    const onChangeTab = (event, value) => {
        setTab(value);
    };

    return (
        <Box p={4} pt={1}>
            <IconButton
                className={classes.closeBtn}
                onClick={onClose}
            >
                <CloseIcon />
            </IconButton>
            <Grid item xs={12} className={classes.tabs}>
                <Tabs
                value={tab}
                onChange={onChangeTab}
                classes={{ root: classes.tabRoot, indicator: classes.tabIndicator }}
                >
                <Tab
                    classes={{ root: classes.tabInactive, selected: classes.tabActive }}
                    value="about"
                    label="About"
                    className={classes.startingTab}
                ></Tab>
                <Tab
                    classes={{ root: classes.tabInactive, selected: classes.tabActive }}
                    value="metric"
                    label="Metric"
                    className={classes.endingTab}
                ></Tab>
                </Tabs>
            </Grid>
            {
                tab === 'about' ? (
                    <Grid item xs={12} className={classes.aboutBox}>
                        <Typography variant="h6" component="div" className={classes.sectionTitle}>
                            About the scenario
                        </Typography>
                        <Typography variant="body2" component="p" className={classes.sectionContent}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia, quis nostrud exercitation ullamco labo is nisi ut aliquip ex ea com. Duis aute irure dolorin reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat upidatat non proident, sunt in culpa qui officia deserunt mollit anim. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia, quis nostrud.
                        </Typography>
                        <Typography variant="h6" component="div" className={classes.sectionTitle}>
                            About the Big River Policy
                        </Typography>
                        <Typography variant="body2" component="p" className={classes.sectionContent}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim venia, quis nostrud exercitation ullamco labo is nisi ut aliquip ex ea com duis aute irure. <br/><br/> Learn More about this Big River Policy at the Kyl Center website.
                        </Typography>
                    </Grid>
                ) : (
                    <Grid item xs={12} className={classes.aboutBox}>
                        {
                            metrics[chart].map((metric) => (
                                <>
                                    <Typography variant="body2" component="p" className={classes.metricTitle}>
                                        { metric.label }
                                    </Typography>
                                    <Typography variant="h6" component="div" className={classes.metricValue}>
                                        { metric.value }
                                    </Typography>        
                                </>
                            ))
                        }
                    </Grid>
                )
            }
        </Box>
    );
};

export default AboutSidebar;